module.exports = __webpack_public_path__ + "media/images/front/toppage_kyushudentalshow_sp-9e2f8e5c6d2ce5d9e3ee1a7e4483fe3c.png";